import { Box } from '@mui/material';

import Send from '@/assets/icons/Send';
import Typography from '@/components/Typography';
import LoadingIndicator from '@/features/AIChat/AskGXDrawer/components/LoadingIndicator/LoadingIndicator';
import { useChat } from '@/features/AIChat/context/useChat';

const NoMessagesScreen = ({
  prompts = [
    'What data have you launched recently?',
    'What Canadian crude data do you have?',
    'Give me an overview of your LPG data with codes',
    'What was the Eurobob price yesterday?',
    'What crude grade increased the most in the past 3 months?'
  ]
}: {
  prompts?: string[];
}) => {
  const { sendMessage } = useChat();
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        background: 'var(--GX-Main-Background, #070818)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        overflow: 'auto'
      }}
    >
      <Typography
        component='div'
        sx={{
          color: '#FFF',
          fontFamily: 'Cairo',
          fontSize: '32px',
          fontStyle: 'normal',
          fontWeight: 500,
          display: 'flex',
          gap: '16px',
          alignItems: 'center',
          padding: '10px'
        }}
      >
        <LoadingIndicator animate={false} />
        What data can I get?
      </Typography>
      <Typography
        sx={{
          fontSize: '20px',
          mt: '16px'
        }}
      >
        Here are some things you can try
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          mt: '16px'
        }}
      >
        {prompts.map(prompt => (
          <Box
            key={prompt}
            sx={{
              width: '420px',
              height: '50px',
              padding: '12px 16px',
              background: 'var(--GX-action-bar-button-tile, rgba(248, 248, 248, 0.20))',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              cursor: 'pointer'
            }}
            onClick={() => {
              sendMessage(prompt);
            }}
          >
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 500
              }}
            >
              {prompt}
            </Typography>
            <Send sx={{ fontSize: '24px' }} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
export default NoMessagesScreen;
